// extracted by mini-css-extract-plugin
export default {"asianWrapper":"styles_asianWrapper__ITCwx","asianWrapper__classicNavigation":"styles_asianWrapper__classicNavigation__VTvxr"};